import React from "react";

const Home = React.lazy(() => import("./pages/home"));
const Login = React.lazy(() => import("./pages/login"));
const Splash = React.lazy(() => import("./pages/splash"));
const Introduction = React.lazy(() => import("./pages/introduction"));
const Survey = React.lazy(() => import("./pages/survey"));
const Guide = React.lazy(() => import("./pages/guide"));
const Carddeck = React.lazy(() => import("./pages/carddeck"));
const Error = React.lazy(() => import("./pages/error"));
const Study = React.lazy(() => import("./pages/study"));
const Purchase = React.lazy(() => import("./pages/purchase"));
const MyPage = React.lazy(() => import("./pages/mypage"));
const Summary = React.lazy(() => import("./pages/summary"));
const Store = React.lazy(() => import("./pages/store"));

const routes = [
  { path: "/", element: Home },
  { path: "/login/*", element: Login },
  { path: "/splash", element: Splash },
  { path: "/introduction", element: Introduction },
  { path: "/survey/*", element: Survey },
  { path: "/guide", element: Guide },
  { path: "/carddeck/*", element: Carddeck },
  { path: "/error", element: Error },
  { path: "/study/*", element: Study },
  { path: "/purchase/*", element: Purchase },
  { path: "/mypage/*", element: MyPage },
  { path: "/summary/*", element: Summary },
  { path: "/store/*", element: Store },
];


export default routes;
